import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { CONFIG } from '../constants/constants';

import { ProyectoEstadoDTO } from '../dto/proyecto.dto';

/**
 * servicio para hacer CRUD en la entidad menu_proyecto
 * menu de navegacion del proyecto
 */
@Injectable({
    providedIn: 'root',
})
export class MenuProyectoService {
    httpHeaders = new HttpHeaders({ 'Content-Type': 'application/json' });

    constructor(private http: HttpClient) {}

    public actualizarEstadoProyecto(datos: ProyectoEstadoDTO): Promise<any> {
        return this.http
            .post<any>(CONFIG.WS_END_POINT + 'menu-proyecto/proyecto', datos)
            .toPromise();
    }
}
